module.exports = {"TXTWCL_Resend_in_N0":{"id":"TXTWCL_Resend_in_N0","defaultMessage":"Resend in {0}"}}